<!-- An entry ("article") from the dictionary. -->

<template>

  <div class='main-content'>

    <article>

      <ErrorAlert :error="article.error" />
      <b-spinner v-if="article.loading" label="Spinning"></b-spinner>

      <p v-else-if="$route.query.from && $route.query.from_id" class="redirected-msg">Doorgestuurd vanaf <router-link :to="slugify($route.query.from, $route.query.from_id)">{{ $route.query.from }}</router-link></p>
      <div v-html="article.html" />

    </article>

  </div>
  
</template>

<script lang="ts">
import Vue, { VueConstructor } from 'vue';
import ErrorAlert from '@/generic/components/ErrorAlert.vue';
import { ArticleState } from '@/types/article';
import { slugify } from '@/util/util';

export default Vue.extend({

  components: {
    ErrorAlert,
  },

  props: {
    article: Object as () => ArticleState,
  },

  methods: {
    slugify,
  },
});

</script>

<!-- Component styles are scoped, article styles (below) are not -->
<style scoped lang="scss">

@import '@/scss/_variables.scss';

.main-content {
  margin: 0;
  background-color: $white;
}

article {
  margin: 1.5em 2em 3em 2em;
}

</style>

<!-- Article CSS cannot be scoped because we dynamically paste in HTML -->
<style lang="scss">

@import '@/scss/_variables.scss';

.redirected-msg {
  font-style: italic;
  font-size: 80%;
}

article {
  text-align: left;
  max-width: 50rem;

  .title-container {
    h2 {
      display: inline-block;
    }
  
    h3.synoniemen {
      font-size: 1.3rem;
  
      &::before {
        content: 'Synoniemen: ';
      }
    }

    p.volledige-term {
      font-weight: bold;
      font-style: italic;
    }
  }

  .niet-domein-specifiek {
    margin-bottom: 1rem;

    p {
      margin: 0;
    }

    p.afkorting::before {
      content: 'Afkorting: ';
    }

    p.uitspraak::before {
      content: 'Uitspraak: ';
    }

    p.variant::before {
      content: 'Variant: ';
    }
  
    p.etymologie::before {
      content: 'Etymologie: ';
    }

    p.grammatica::before {
      content: 'Grammaticale uitleg: ';
    }
  }

  .domein-type {
    font-family: "schoolboek", "Helvetica Neue", sans-serif;
  }

  .notabene::before {
    content: 'N.B.: ';
  }

  .description-group {
    border-top: 1px solid $black;
    padding-top: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;

    h3.description-group--title {
      font-size: 1.3rem;
      text-transform: capitalize;
    }
  }

  span.lang {
    position: relative;
    top: -0.2rem;
    margin: 0 0.6rem;
    padding: 0.1rem 0.3rem;
    font-family: "schoolboek", "Helvetica Neue", sans-serif;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: $grey;
    background-color: $white;
    border: 1px solid $grey;
    user-select: none;
  }

  em {
    font-style: normal;
    font-weight: bold;
    color: $highlight-color;
  }
}
</style>
